<template>
  <div
    class="ui-block popup-chat popup-chat-responsive mobile-box-size"
    tabindex="-1"
    role="dialog"
    aria-labelledby="popup-chat-responsive"
    aria-hidden="true"
    :class="{ 'open-chat': isActive, 'closed-chat': !isActive }"
    @click.stop="open"
    @paste="pasteFile"
    :key="displayKey"
  >
    <div class="modal-content">
      <div v-if="mobileChatBox" class="header-field">
        <div v-if="!partner && chatMsgs.type === 'MY_ITEM_MESSAGE'" class="partner-box">
          <img class="header-item-image" @click.stop="checkRoute()" :src="getItemImagePath(chatMsgs.key)" alt="Item" />
          <div class="header-box-text">
            <p class="header-box-title" @click.stop="checkRoute()"> {{ chatMsgs.key.title }}</p>
            <p class="header-subtitle"> {{ headerText }} you at {{ timeAgo }}</p>
          </div>
          <div class="close-button" @click.stop="close">
            <svg v-if="mobileChatBox" class="olymp-mobile-delete">
              <use
                xlink:href="/svg-icons/sprites/icons.svg#olymp-little-delete"
              />
            </svg>
          </div>
        </div>
        <div v-if="partner && chatMsgs.type === 'USERS_ITEM_MESSAGE'" class="partner-box">
          <img class="header-item-image" @click.stop="checkRoute()" :src="getItemImagePath(chatMsgs.key)" alt="Item" />
          <div class="header-box-text">
            <p class="header-box-title" @click.stop="checkRoute()"> {{ chatMsgs.key.title }}</p>
            <p class="header-subtitle"> {{ headerText }} {{ partner.firstName }} at {{ timeAgo }}</p>
          </div>
          <div class="close-button" @click.stop="close">
            <svg v-if="mobileChatBox" class="olymp-mobile-delete">
              <use
                xlink:href="/svg-icons/sprites/icons.svg#olymp-little-delete"
              />
            </svg>
          </div>
        </div>
        <div v-if="!partner && chatMsgs.type === 'USERS_ITEM_MESSAGE'" class="partner-box">
          <img class="header-item-image" @click.stop="checkRoute()" :src="getItemImagePath(chatMsgs.key)" alt="Item" />
          <div class="header-box-text">
            <p class="header-box-title" @click.stop="checkRoute()"> {{ chatMsgs.key.title }}</p>
            <p class="header-subtitle"> {{ headerText }} {{ chatMsgs.partner.firstName }} at {{ timeAgo }}</p>
          </div>
          <div class="close-button" @click.stop="close">
            <svg v-if="mobileChatBox" class="olymp-mobile-delete">
              <use
                xlink:href="/svg-icons/sprites/icons.svg#olymp-little-delete"
              />
            </svg>
          </div>
        </div>
        <div v-if="(chatMsgs.type === 'MY_GROUP_MESSAGE' || chatMsgs.type === 'MY_MODERATOR_GROUP_MESSAGE')" class="partner-box">
          <img class="header-group-image" @click.stop="checkRoute()" :src="getGroupImagePath(chatMsgs.key)" alt="Group" />
          <div class="header-box-text">
            <p class="header-box-title" @click.stop="checkRoute()"> {{ chatMsgs.key.name }}</p>
            <p class="header-subtitle">  members | Moderator: {{ moderatorName }} </p>
          </div>
          <div class="close-button" @click.stop="close">
            <svg v-if="mobileChatBox" class="olymp-mobile-delete">
              <use
                xlink:href="/svg-icons/sprites/icons.svg#olymp-little-delete"
              />
            </svg>
          </div>
        </div>
        <div v-if="(chatMsgs.type === 'MY_GARAGE_MESSAGE' || chatMsgs.type === 'USERS_GARAGE_MESSAGE')" class="partner-box">
          <img class="header-group-image" @click.stop="checkRoute()" :src="require('@/assets/garage.jpg')" alt="Garage" />
          <div class="header-box-text">
            <p class="header-box-title" @click.stop="checkRoute()"> {{ chatMsgs.key.garageName }}  {{ garageDates }} </p>
            <div class="header-box-subtitle">
              <p class="header-subtitle">Sale hosted by {{ chatMsgs.key.owner }}   </p>
              <p class="ended-sale" v-if="isEndDatePassed(chatMsgs.key.endDate)">  (this sale has ended)</p>
            </div>
          </div>
          <div class="close-button" @click.stop="close">
            <svg v-if="mobileChatBox" class="olymp-mobile-delete">
              <use
                xlink:href="/svg-icons/sprites/icons.svg#olymp-little-delete"
              />
            </svg>
          </div>
        </div>
      </div>
      <div v-else class="modal-header" @click.stop="close">
        <router-link :to="`/s-app/profile-page/${msgsUserId}`" class="title" onMouseOver="this.style.color='white'">
          {{ getChatUsername(chatMsgs.partner)}}
        </router-link>
        <div class="more">
          <svg v-if="!mobileChatBox" class="olymp-little-delete">
            <use
              xlink:href="/svg-icons/sprites/icons.svg#olymp-little-delete"
            />
          </svg>
          <md-button v-else
          class="md-icon-button back-button"
          @click="close()"
        >
          <md-icon>arrow_back</md-icon>
        </md-button>
        </div>
      </div>
      <div class="modal-body">
        <div v-if="!mobileChatBox" class="key-name-box" :class="chatType">
          <router-link
            v-if="checkMessageKeyHasTitle(chatMsgs)"
            :to="`/s-app/item-details/${getItemId(chatMsgs)}`"
          >
            <img
              class="avatar"
              :src="getItemImagePath(chatMsgs.key)"
              alt="Item"
            />
          </router-link>
          <router-link
            v-else-if="checkMessageKeyHasTitle(chatMsgs)"
            :to="`/s-app/item-details/${getItemId(chatMsgs)}`"
          >
            <img
              class="avatar"
              :src="getItemImagePath(chatMsgs.key)"
              alt="Item"
            />
          </router-link>
          <router-link v-else :to="`/s-app/group-page/${getGroupId(chatMsgs)}`">
            <img
              class="avatar"
              :src="getGroupImagePath(chatMsgs.key)"
              alt="Group"
            />
            <md-icon v-if="iAmModerator" class="md-icon md-primary"
              >security
            </md-icon>
          </router-link>
          <span class="text key-name">{{ keyName }}</span>
        </div>
        <div class="mCustomScrollbar mobile-content-area-size" id="chat-display">
          <MsgsChatDisplay
            :receiver="chatMsgs"
            :messages="getAllMsgs(chatMsgs)"
            :marginChatPopup="true"
            dataCy="chat-dialog-content"
            ref="dialogDisplay"
          />
        </div>
        <form class="need-validation" v-if="msgsUserId !== -1">
          <div
            class="form-group label-floating is-empty"
            @keyup.enter.exact.prevent="send"
            @keydown.enter.exact.prevent
          >
            <section class="container mobile-text-area-size row">
              <div class="text-area col col-9">
                <TextArea
                  v-model="message"
                  :placeholder="labelText"
                  class="popup-textarea"
                  ref="textArea"
                  :disabled="isSending"
                  data-cy="textarea-chat"
                />
              </div>
              <div class="btn-reply">
                <div class="chat-emoji">
                  <ChatEmoji @emoji="setEmojiMsg" :noAttachments="true" />
                </div>
                <div class="">
                  <SButtonMaterial
                    buttonType="button"
                    class="send-button"
                    color="tertiary"
                    textColor="white"
                    materialClass="dense"
                    iconWithoutText="send"
                    iconColor="white"
                    @button="send"
                    :disabled="isSending || !message"
                    data-cy="chat-send"
                  />
                </div>
              </div>
            </section>
            <LoadingSpinner position="absolute" v-if="isSending" />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MsgsChatDisplay from "@/components/molecules/MsgsChatDisplay";
import TextArea from "@/components/atoms/TextArea";
import UserHelperVue from "@/mixins/UserHelper.vue";
import GroupHelperVue from "@/mixins/GroupHelper.vue";
import ItemHelperVue from "@/mixins/ItemHelper.vue";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import GarageHelperVue from "@/mixins/GarageHelper.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import ChatEmoji from "@/components/atoms/ChatEmoji";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";
import formatISO from 'date-fns/formatISO';

export default {
  name: "ChatModalPopup",
  props: ["chatMsgs"],
  mixins: [
    UserHelperVue, 
    GroupHelperVue, 
    ChatHelperVue, 
    ItemHelperVue, 
    GarageHelperVue
  ],
  components: {
    TextArea,
    MsgsChatDisplay,
    ChatEmoji,
    SButtonMaterial,
    LoadingSpinner,
  },
  data() {
    return {
      isActive: false,
      message: "",
      payload: {},
      emojiUnicode: [],
      emojiArray: [],
      labelText: "Type here...",
      errorAttachment: false,
      file: [],
      isSending: false,
      displayKey: 0,
      mobileChatBox: window.innerWidth < 721 ? true : false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    msgsUserId() {
      return this.chatMsgs.partner?.id ?? -1;
    },
    keyName() {
      return this.chatMsgs.key?.name ?? this.chatMsgs.key?.title ?? this.chatMsgs.key?.garageName;
    },
    headerText(){
      switch (this.chatMsgs.key.type) {
        case 1:
          return "Item offer posted by";
        case 2:
          return "Item request posted by";
        case 3:
          return "Item offer posted by";
        case 4:
          return "Item request posted by";
        default:
          return "";
      }
    },
    timeAgo() {
      const date = new Date(this.chatMsgs.key.createdAt);
      return date.toLocaleString('en-us', { dateStyle: 'short' });
    },
    moderatorName() {
      if (this.chatMsgs.messages[0].receiver.id === this.loggedUser.id) {
        return this.chatMsgs.messages[0].sender.firstName;
      }
      return this.chatMsgs.messages[0].receiver.firstName;
    },
    garageDates() {
      const dateStart = new Date(this.chatMsgs.key.startDate);
      const dateEnd = new Date(this.chatMsgs.key.endDate);
      let startDate = formatISO(dateStart, { representation: 'date' });
      let endDate = formatISO(dateEnd, { representation: 'date' });
      let result = "(" + startDate.slice(5) + " to " + endDate.slice(5) + ")";
      return result;
    },
    chatType() {
      if(this.isGarageChat)
        return "garage";
      if(this.isItemChat)
        return "item";     
      return "group";
    },
    iAmModerator() {
      if (
        this.chatMsgs.type === "MY_GROUP_MESSAGE" ||
        this.chatMsgs.type === "MY_MODERATOR_GROUP_MESSAGE"
      ) {
        const found = this.myModeratedGroups.find((group) => {
          return group.groupId === this.chatMsgs.key.id;
        });
        return found ? true : false;
      }
      return false;
    },
  },
  methods: {
    updateKey() {
      this.displayKey += 1;
    },
    checkMessageKeyHasTitle(chatMessage) {
      if (chatMessage !== undefined) {
        return chatMessage.key?.title ? true : false;
      }
      return false;
    },
    checkRoute() {
      if (this.mobileChatBox)
        this.close();
      if (this.chatMsgs.type === "MY_ITEM_MESSAGE" || this.chatMsgs.type === "USERS_ITEM_MESSAGE"){
        this.$router.push(`/s-app/item-details/${this.chatMsgs.key.id}`);
      } else if (this.chatMsgs.type === "MY_GROUP_MESSAGE" || this.chatMsgs.type === "MY_MODERATOR_GROUP_MESSAGE") {
        this.$router.push(`/s-app/group-page/${this.chatMsgs.key.id}`);
      } else if (this.chatMsgs.type === "MY_GARAGE_MESSAGE" || this.chatMsgs.type === "USERS_GARAGE_MESSAGE"){
        localStorage.setItem("garageSale", JSON.stringify(this.chatMsgs.key));
        this.$router.push(`/s-app/garage-sales-detail/${this.chatMsgs.key.id}`);
      }
    },
    isEndDatePassed(endDate) {
      const currentDate = new Date();
      const garageEndDate = new Date(endDate);
      garageEndDate.setDate(garageEndDate.getDate() + 1);
      return garageEndDate < currentDate;
    },
    getItemId(chatMessage) {
      if (chatMessage !== undefined) {
        return chatMessage.key?.id;
      }
      return 0;
    },
    getGroupId(chatMessage) {
      if (chatMessage !== undefined) {
        return chatMessage.key?.id ?? chatMessage.key?.group.id;
      }
      return 0;
    },
    open() {
      console.log(this.chatMsgs)
      this.isActive = true;
      this.$emit("popupOpen", this.isActive);
      this.focusInput();
    },
    close() {
      this.isActive = false;
      this.$emit("popupClose", this.isActive);
    },
    setEmojiMsg(emoji) {
      this.message += String.fromCodePoint(emoji);
    },
    pasteFile(event) {
      this.retrieveImageFromClipboard(event, (imageFile) => {
        this.setAttachment(imageFile);
      });
    },
    isItemChat() {
      return (
        this.chatMsgs.type === "MY_ITEM_MESSAGE" ||
        this.chatMsgs.type === "USERS_ITEM_MESSAGE"
      );
    },
    isGarageChat() {
      return (
        this.chatMsgs.type === "MY_GARAGE_MESSAGE" ||
        this.chatMsgs.type === "USERS_GARAGE_MESSAGE"
      );
    },
    async send() {
      this.isSending = true;
      this.payload = {
        receiver: this.chatMsgs.partner,
        sender: this.loggedUser,
      };

      let newChatUser = false;
      if (!this.chatMsgs.messages[0]) {
        newChatUser = true;
      }
      this.payload.msg = this.message;
      const myDiv = document.getElementById("chat-display");
      myDiv.scrollTop = myDiv.scrollHeight + 500;
      this.$refs.textArea.focus();
      if (
        this.chatMsgs?.type === "USERS_ITEM_MESSAGE" ||
        this.chatMsgs?.type === "MY_ITEM_MESSAGE" ||
        this.chatMsgs.key?.feedType === "NEW_ITEM"
      ) {
        await this.postUserItemMessage({
          message: this.payload,
          partner: this.chatMsgs.key.posterId,
          item: this.chatMsgs.key?.id ?? this.chatMsgs.key?.item.id,
          postMsg: this.message,
          
        });
      } else if(
            this.chatMsgs.type === 'USERS_GARAGE_MESSAGE' || 
            this.chatMsgs.type === 'GARAGE_MESSAGE' ||
            this.chatMsgs.type === 'MY_GARAGE_MESSAGE'
        ) {
            await this.postGarageUserMessage({
              message: this.payload,
              partner: this.chatMsgs.partner.id,
              garage: this.chatMsgs.key?.id ?? this.chatMsgs.key?.id,
              postMsg: this.message,
            });
        
      } else { 
        await this.postUserGroupMessage({
          message: this.payload,
          partner: this.chatMsgs.partner.id,
          group: this.chatMsgs.key?.id ?? this.chatMsgs.key?.group.id,
          postMsg: this.message,
          newChat: newChatUser,
        });
      }
      this.newChatUser = false;
      this.message = "";
      this.payload = {};
      this.isSending = false;
      await this.fetchUserMessages();
      this.$nextTick(() => {
        this.$refs.textArea.focus();
      });
    },
    async setAttachment(f) {
      let newChatUser = false;
      this.file = f.length > 0 ? f[0] : f;
      if (this.chatMsgs.messages) {
        this.payload = this.chatMsgs.messages[0];
      } else {
        this.payload.receiver = { newMessage: {} };
        newChatUser = true;
      }

      try {
        this.isSending = true;
        await this.sendAttachmentFile(newChatUser);
        this.isSending = false;
      } catch (error) {
        console.log(error);
      }
    },
    async sendAttachmentFile(newChatUser) {
      if (
        this.chatMsgs.type === "USERS_ITEM_MESSAGE" ||
        this.chatMsgs.type === "MY_ITEM_MESSAGE" ||
        this.chatMsgs.type === "MY_GARAGE_MESSAGE" ||
        this.chatMsgs.type === "USERS_GARAGE_MESSAGE"
        
      ) {
        await this.sendItemAttachment({
          message: this.payload,
          partner: this.chatMsgs.partner.id,
          item: this.chatMsgs.key?.id ?? this.chatMsgs.key?.item.id,
          file: this.file,
          newChat: newChatUser,
        });
      } else {
        await this.sendGroupAttachment({
          message: this.payload,
          partner: this.chatMsgs.partner.id,
          group: this.chatMsgs.key?.id ?? this.chatMsgs.key?.group.id,
          file: this.file,
          newChat: newChatUser,
        });
      }
      const myDiv = document.getElementById("chat-display");
      myDiv.scrollTop = myDiv.scrollHeight + 500;
    },
    retrieveImageFromClipboard(pasteEvent, callback) {
      if (pasteEvent.clipboardData === false) {
        if (typeof callback == "function") {
          callback(undefined);
        }
      }

      const items = pasteEvent.clipboardData.items;

      if (items === undefined) {
        if (typeof callback == "function") {
          callback(undefined);
        }
      }
      for (const item of items) {
        if (item.type.indexOf("image") === -1) continue;
        const blob = item.getAsFile();
        if (typeof callback == "function") {
          callback(blob);
        }
      }
    },

    focusInput() {
      setTimeout(() => {
        if (this.$refs.textarea !== undefined) {
          this.$refs.textArea.focus();
        }
      }, 1001);
    },
  },

  watch: {
    message() {
      if (this.message.length >= 1) {
        this.labelText = "";
      } else {
        this.labelText = "Type here...";
      }
    },
    $route() {
      this.$nextTick(() => {
        if (this.$route.name === "SMessageCenter" && this.isActive)
          this.close();
      });
    },   
  },
  async mounted() {
    const user = await this.fetchUserProfile(this.chatMsgs.key.posterId);
    console.log(user)
  },
};
</script>

<style scoped>
.spinner-border {
  position: absolute;
  top: 15px;
  right: 148px;
}
.sp-notify {
  height: 236px;
}

.open-chat {
  opacity: 1;
  z-index: 18
}
.closed-chat {
  opacity: 0;
}
</style>

<style lang="scss" scoped>

@media screen and (max-width: 720px) {
  .mobile-box-size {
    min-width: 100%;
    max-width: 100%;
    min-height: 100%;
    max-height: 100%;
    z-index: 20;
    right: 0;
  }
  .mobile-content-area-size {
    height: 80%;
    max-height: 80%;
    overflow: hidden !important;
  }
  .modal-content {
    height: 100vh;
  }
  .modal-body {
    max-height: 100%;
  }
  .mobile-text-area-size {
    width: 120vw;
    max-width: 120%;
  }
  .text-area {
    width: 90%;
  }
  .btn-reply {
    width: 10%;
  }
  .modal-header {
    background-color: white;
    display: flex;
    flex-direction: row-reverse;
    justify-content: center;
    margin-top: 8px;
  }
  .title {
    color: black !important;
    margin-right: 0 !important;
  }
  .more {
    fill: black !important;
    right: 40vw;
  }
  .back-button i {
    color: black !important;
  }
}
.modal-header {
  border-bottom: unset;
}
#drop-notifications span {
  text-align: left;
}
.avatar {
  width: 40px;
  height: 48px;
  object-fit: contain;
}
.key-name-box i.md-icon {
  position: absolute;
  transform: translatex(-10px) translatey(18px);
  background-color: #ffffff;
  border-radius: 100%;
}
.key-name-box {
  height: 48px;
  border: 1px solid #939393;
  text-align: center;
  border-radius: 0px 0px 4px 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.key-name-box.item {
  background: rgba(57, 86, 147, 0.2);
}
.key-name-box.group {
  background: rgba(105, 40, 123, 0.2);
}
.olymp-mobile-delete {
  width: 15px;
  height: 15px;
}
.close-button {
  width: 10%;
  display: flex;
  justify-content: center;
  cursor: pointer;
}
.key-name-box.garage {
  background: rgba(105, 40, 123, 0.2);
}
.key-name {
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 1.25px;
  color: $black;
  opacity: 0.8;
  padding-left: 1rem;
}
.md-avatar {
  margin: unset;
}
.send-button {
  border-radius: 50%;
}
.md-button {
  min-width: unset;
  width: 35px;
  height: 35px;
}
.btn-reply {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;
}
.popup-textarea {
  margin-bottom: unset !important;
}
.form-control:focus {
  border: unset;
}
.header-item-image {
  height: 90%;
  cursor: pointer;
}
.header-box-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 73%;
  line-height: 6px;
  margin: 8px;
}
.partner-box {
  height: 100%;
  background: $white;
  border: 2px solid #c4c4c4;
  width: 100%;
  border-radius: 4px 4px 8px 8px;
  display: flex;
  align-items: center;
}
.header-box-title {
  font-weight: bold;
    font-size: 20px;
    line-height: 20px;
    margin: 0;
    color: black;
    cursor: pointer;
}
.header-subtitle {
  font-size: 12px;
  line-height: 12px;
  margin: 10px 0 10px 5px;
  color: dimgray;
}
.header-group-image {
  height: 70%;
  cursor: pointer;
}
.header-box-subtitle {
  display: flex;
}
.ended-sale {
  font-size: 12px;
  line-height: 12px;
  margin: 10px 0 10px 5px;
  color: red;
}
.header-field {
  height: 10%;
}
</style>
<style lang="scss">
.popup-chat .form-group {
  border-top: 1px solid $dark;
}
.popup-chat-responsive {
  border: 1px solid $dark;
}
.title {
  font-weight: bold;
}
</style>
